import type { Middleware, PayloadAction } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { pathEq } from 'ramda';

type TRedirectPayload = {
  status: number;
  data?: {
    redirectUrl?: string;
    data?: {
      redirectUrl?: string;
    };
  };
};

export type TRedirectActionErr = PayloadAction<TRedirectPayload>;

export const isRedirectActionErr = (action: PayloadAction<unknown>): action is TRedirectActionErr =>
  pathEq(['status'], 300)(action.payload);

export const appApiRedirectMiddleware: Middleware = () => next => action => {
  if (isRejectedWithValue(action)) {
    const redirectUrl = action?.payload?.data?.redirectUrl || action?.payload?.data?.data?.redirectUrl;
    if (isRedirectActionErr(action) && window.location.href !== redirectUrl) {
      window.location.href = redirectUrl;
    }
  }

  return next(action);
};
